import React from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as yup from "yup";
import { useGetMemberquestionsQuery } from "../../../store/api/member";
import { usePostMealsAnswerMutation } from "../../../store/api/meals";
import { useNavigate } from "react-router-dom";

function MemberAnswers() {
  const navigate = useNavigate();
  const { data: backendQuestions, error, isLoading } = useGetMemberquestionsQuery();
  const [postMealsAnswerMutation] = usePostMealsAnswerMutation();

  if (isLoading) {
    return <div></div>;
  }

  if (error) {
    return <div>Error loading questions: {error.message}</div>;
  }

  // Create validation schema dynamically based on the questions
  const validationSchema = yup.object().shape(
    backendQuestions.reduce((schema, question) => {
      schema[question.id] = yup.string().required("This field is required");
      return schema;
    }, {})
  );

  // Initial values for Formik
  const initialValues = backendQuestions.reduce((values, question) => {
    values[question.id] = "";
    return values;
  }, {});

  const handleSubmit = async (values, { setSubmitting, setStatus }) => {
    try {
      const formattedAnswers = backendQuestions.map((question) => ({
        question: question.id,
        answer_text: values[question.id],
      }));

      const response = await postMealsAnswerMutation(formattedAnswers);

      if (response.error) {
        setStatus({ type: "error", message: response.error.data?.error || "An error occurred" });
      } else {
        setStatus({ type: "success", message: "User Answer created Successfully" });
        setTimeout(() => navigate("/member-answers", { state: { pageName: "Answer" } }), 2000);
      }
    } catch (error) {
      setStatus({ type: "error", message: "Error creating userAnswer: " + error.message });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="w-full mx-auto  rounded-xl mt-3 bg-white">
      <div className="bg-primary text-white text-center py-4 rounded-t-xl">
        <h2 className="text-2xl font-semibold">Member Questions</h2>
      </div>
      <div className="p-6">
        <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={handleSubmit}>
          {({ status, isSubmitting }) => (
            <Form>
              {backendQuestions.map((question) => (
                <div key={question.id} className="mb-4">
                  <label className="block font-medium text-gray-700 mb-2">{question.question_text}</label>
                  <Field
                    type="text"
                    name={question.id}
                    className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
                    placeholder="Your answer..."
                  />
                  <ErrorMessage name={question.id} component="div" className="text-red-500 text-sm mt-1" />
                </div>
              ))}

  
              {status?.message && (
                <div
                  className={`col-span-2 w-full mt-3 rounded-lg px-4 py-3 text-md font-medium border ${
                    status.type === "success"
                      ? "bg-green-100 text-green-700 border-green-300"
                      : "bg-red-100 text-red-700 border-red-300"
                  }`}
                  role="alert"
                >
                  {status.message}
                </div>
              )}

              {/* Submit Button */}
              <div className="flex justify-end mt-2">
                <button
                  type="submit"
                  className="bg-secondary text-white px-6 py-3 rounded-lg"
                  disabled={isSubmitting}
                >
                  {isSubmitting ? "Submitting..." : "Submit Answers"}
                </button>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
}

export default MemberAnswers;
